import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { auth } from './auth';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function AddNoteForm() {
  const { issueId } = useParams();
  const location = useLocation();
  const user = auth.currentUser;
  const userEmail = user && user.email ? user.email : '';
  const [byWhom, setByWhom] = useState('');
  const [dateEntered, setDateEntered] = useState('');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState('');
  const [charCount, setCharCount] = useState(0);
  const [isTooLong, setIsTooLong] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUserName() {
      if (!userEmail) {
        setByWhom('');
        return;
      }
      try {
        const usersSnapshot = await getDocs(collection(db, 'users'));
        let matchedName = '';
        usersSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.email && data.email.toLowerCase() === userEmail.toLowerCase()) {
            matchedName = data.name;
          }
        });
        setByWhom(matchedName || userEmail.split('@')[0]);
      } catch (e) {
        setByWhom(userEmail.split('@')[0]);
      }
    }
    fetchUserName();
    setDateEntered(new Date().toISOString()); // Use full ISO string for date+time
    // Remove auto-insert of date/time into Notes field
  }, [userEmail, location.search]);

  function handleQuillChange(value) {
    // Remove HTML tags to count plain text length
    const plainText = value.replace(/<[^>]+>/g, '');
    setCharCount(plainText.length);
    if (plainText.length > 600) {
      setIsTooLong(true);
    } else {
      setIsTooLong(false);
      setNotes(value);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    const plainText = notes.replace(/<[^>]+>/g, '');
    if (plainText.length > 600) {
      setError('Notes cannot exceed 600 characters.');
      alert('Notes cannot exceed 600 characters.');
      return;
    }
    try {
      await addDoc(collection(db, 'issues', issueId, 'notes'), {
        dateEntered,
        byWhom,
        notes,
        createdAt: new Date().toISOString()
      });
      navigate(`/issues/${issueId}/progress`);
    } catch (err) {
      setError('Failed to add note.');
    }
  }

  return (
    <form className="issue-form" onSubmit={handleSubmit}>
      <h2>Add Progress Note</h2>
      <label>Date Entered</label>
      <input type="text" value={dateEntered} readOnly />
      <label>By Whom</label>
      <input value={byWhom} readOnly />
      <label>Notes (max 600 chars)</label>
      <ReactQuill value={notes} onChange={handleQuillChange} style={{ minHeight: 180, height: 180, marginBottom: 16 }} />
      <div style={{ fontSize: '0.95rem', color: '#888', marginBottom: 8 }}>
        {charCount}/600 characters
      </div>
      {error && <div className="auth-error">{error}</div>}
      <button type="submit" disabled={isTooLong}>Save Note</button>
    </form>
  );
}
